<div *ngIf="voucherDetails!=null">
    <dx-form [formData]="voucherDetails" (customizeItem)="customizeItem($event)" style="padding-bottom:5px" [colCount]="2">
        <dxi-item dataField="VoucherCode" caption="Voucher code" editorType="dxTextBox"
            [editorOptions]="{ readOnly:true}">
        </dxi-item>

        <dxi-item dataField="OriginalBalance" [editorOptions]="{readonly:true, format:'£#,##0.00'}">
        </dxi-item>

        <dxi-item dataField="AmountRedeemed" [editorOptions]="{readonly:true, format:'£#,##0.00'}">
        </dxi-item>

        <dxi-item dataField="RemainingBalance" [editorOptions]="{readonly:true, format:'£#,##0.00'}">
        </dxi-item>

        <dxi-item dataField="CreatedDate" format="d MMM yyyy H:mm" editorType="dxDateBox"
            [editorOptions]="{displayFormat:'d MMM yyyy HH:mm', formatString:'d MMM yyyy HH:mm',  type:'datetime' , readOnly:true }">
        </dxi-item>

        <dxi-item dataField="ExpiryDate" format="d MMM yyyy H:mm" editorType="dxDateBox"
            [editorOptions]="{displayFormat:'d MMM yyyy HH:mm', formatString:'d MMM yyyy HH:mm',  type:'datetime', readOnly:true }">
        </dxi-item>

        <dxi-item dataField="Expired" editorType="dxCheckBox" [editorOptions]="{readOnly:true }" > 
        </dxi-item>
    </dx-form>

    <dx-data-grid *ngIf="showHistory" #gridVoucherHistory [dataSource]="voucherDetails.History" [showBorders]="true" [allowColumnResizing]=true
        [rowAlternationEnabled]=true>
        <dxo-pager [visible]="true" infoText="Total Records : {2}" [showInfo]="true"></dxo-pager>
        <dxo-sorting mode="none"></dxo-sorting>
        <dxo-scrolling mode="virtual" columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-header-filter [visible]="false"></dxo-header-filter>
        <dxo-group-panel [visible]="false"></dxo-group-panel>
        <dxo-search-panel [visible]="false"></dxo-search-panel>

        <dxi-column dataField="TransactionDate" dataType="date" format="EEE d MMM yyyy HH:mm"></dxi-column>
        <dxi-column dataField="Description" caption="Details"></dxi-column>
        <dxi-column dataField="Credit" format="£#,##0.00"></dxi-column>
        <dxi-column dataField="Debit" format="£#,##0.00"></dxi-column>
        <dxi-column dataField="BranchName"></dxi-column>
        <dxi-column dataField="ClientName"></dxi-column>
    </dx-data-grid>
</div>
<div *ngIf="voucherDetails==null" class="centeredTextBox dx-theme-generic-typography">
    <span>{{message}}</span>
</div>